// extracted by mini-css-extract-plugin
export var modalFooter = "_m6-0";